export enum DatePickerEnums {
    DATE = 'date',
    TIME = 'time',
    DATETIME = 'datetime',
  }